export default __webpack_public_path__ + "static/media/bannerBlueBG.e13d493a.jpg";